import { useState } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SlabDialog from "./SlabDialog";
import DeleteConfirm from "./DeleteConfirm";

const SlabTable = ({ slabs, onAdd, onUpdate, onDelete }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editSlab, setEditSlab] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={500}>
          Weight Slabs
        </Typography>
        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={() => {
            setEditSlab(null);
            setDialogOpen(true);
          }}
        >
          Add Slab
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ borderRadius: 2 }}
      >
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "action.hover" }}>
              <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>
                From (kg)
              </TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>
                To (kg)
              </TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>
                Rate/kg (₹)
              </TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>
                Min Charge (₹)
              </TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: 12, width: 80 }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {slabs.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                  sx={{
                    py: 3,
                    color: "text.secondary",
                    fontSize: 12,
                  }}
                >
                  No slabs yet. Click "Add Slab" to create one.
                </TableCell>
              </TableRow>
            )}
            {slabs.map((slab) => (
              <TableRow key={slab.id} hover>
                <TableCell sx={{ fontSize: 12 }}>{slab.fromWeight}</TableCell>
                <TableCell sx={{ fontSize: 12 }}>{slab.toWeight}</TableCell>
                <TableCell sx={{ fontSize: 12, fontWeight: 500 }}>
                  ₹{slab.ratePerKg}
                </TableCell>
                <TableCell sx={{ fontSize: 12 }}>₹{slab.minCharge}</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setEditSlab(slab);
                        setDialogOpen(true);
                      }}
                    >
                      <EditIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => setDeleteTarget(slab)}
                    >
                      <DeleteIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <SlabDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        title={editSlab ? "Edit Slab" : "Add Slab"}
        initial={
          editSlab
            ? {
                fromWeight: editSlab.fromWeight,
                toWeight: editSlab.toWeight,
                ratePerKg: editSlab.ratePerKg,
                minCharge: editSlab.minCharge,
              }
            : undefined
        }
        onSubmit={(data) =>
          editSlab ? onUpdate(editSlab.id, data) : onAdd(data)
        }
      />
      <DeleteConfirm
        open={!!deleteTarget}
        onOpenChange={(o) => !o && setDeleteTarget(null)}
        onConfirm={() => {
          if (deleteTarget) onDelete(deleteTarget.id);
          setDeleteTarget(null);
        }}
        itemName={
          deleteTarget
            ? `Slab ${deleteTarget.fromWeight}-${deleteTarget.toWeight} kg`
            : ""
        }
      />
    </>
  );
};

export default SlabTable;
